import React, { useEffect } from 'react';
import { InfoBodySubTitle } from './InfoBodySubTitles';
import { InfoBodyConsultationMemoText, InfoBodyDiagnosisMemoText } from 'constants/viewDetailDiagnosisPageConstants';
import styled from 'styled-components';
import { font, palette } from 'styles/Global/globalStyles';
import BasicButton from 'components/Buttons/BasicButton';
import { TextareaAutosize } from '@mui/material';
import { InfoBodyDiagnosisMemoProps } from 'models/Hospital/viewDetailDiagnosisPageTypes';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { isConsultationHospital } from 'utils/hospitalUtils';
import { useLoginStore } from 'store/useLoginDataStore';
import { DCKTextArea } from 'styles/Global/TextAreaStyles';

const InfoBodyDiagnosisMemo = ({
    setDiagnosisMemo,
    diagnosisMemo,
    updateMemo,
    diagnosisInfoData,
    memoChangeBtn,
    setMemoChangeBtn,
    clickCancelButtonInMemo,
    initDiagnosisMemo,
}: InfoBodyDiagnosisMemoProps) => {
    const { loginData } = useLoginStore();
    useEffect(() => {
        if (diagnosisInfoData.prescriptionMemo) {
            return setMemoChangeBtn(true);
        }
        return setMemoChangeBtn(false);
    }, [diagnosisInfoData]);

    return (
        <>
            <InfoBodySubTitle
                title={isConsultationHospital(loginData.hospitalId) ? InfoBodyConsultationMemoText.title : InfoBodyDiagnosisMemoText.title}
                firstSubText={isConsultationHospital(loginData.hospitalId) ? InfoBodyConsultationMemoText.firstSubText : InfoBodyDiagnosisMemoText.firstSubText}
                secondSubText={isConsultationHospital(loginData.hospitalId) ? InfoBodyConsultationMemoText.secondSubText : InfoBodyDiagnosisMemoText.secondSubText}
            />
            <DCKTextArea
                style={{ marginTop: '36px' }}
                minRows={6}
                placeholder={isConsultationHospital(loginData.hospitalId) ? InfoBodyConsultationMemoText.textAreaPlaceholder : InfoBodyDiagnosisMemoText.textAreaPlaceholder}
                onChange={(e) => setDiagnosisMemo(e.target.value)}
                value={diagnosisMemo}
                disabled={memoChangeBtn}
            />
            <ButtonWrapper>
                {!memoChangeBtn && !diagnosisMemo && !initDiagnosisMemo ? (
                    ''
                ) : !memoChangeBtn ? (
                    <>
                        <BasicButton $width='215px' $type='anotherFill' onClick={clickCancelButtonInMemo}>
                            취소
                        </BasicButton>
                        <BasicButton $width='215px' $type='fill' disabled={diagnosisInfoData.prescriptionMemo === diagnosisMemo} onClick={updateMemo}>
                            저장하기
                        </BasicButton>
                    </>
                ) : (
                    <BasicButton $width='310px' disabled={!diagnosisMemo} onClick={() => setMemoChangeBtn(false)} $type='outLine'>
                        수정하기
                    </BasicButton>
                )}
            </ButtonWrapper>
        </>
    );
};

export default InfoBodyDiagnosisMemo;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 40px;
    gap: 10px;
`;
